import { useState } from "react";
import { BookOpen, PenLine, Sparkles, Zap, Shield, Eye } from "lucide-react";
import { KeywordResearchTool } from "./KeywordResearchTool";
import { ContentWriterTool } from "./ContentWriterTool";
import { BacklinkCheckerTool } from "./BacklinkCheckerTool";
import { SiteSpeedTool } from "./SiteSpeedTool";
import { MonitoringDashboard } from "./MonitoringDashboard";

export const SEOToolsSection = ({ t, language, userEmail }) => {
  const [activeTab, setActiveTab] = useState('keyword');

  return (
    <section className="py-20 px-6 bg-[var(--color-bg)]" id="seo-tools" data-testid="seo-tools-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#a855f7]/10 text-[#a855f7] text-sm font-semibold font-['JetBrains_Mono'] uppercase tracking-wider mb-4">
            <Sparkles className="w-4 h-4" />
            AI-Powered
          </div>
          <h2 className="text-3xl md:text-4xl font-black tracking-tighter font-['Cabinet_Grotesk'] text-white mb-4">{t.tools_title}</h2>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex border border-[var(--color-border)] bg-[var(--color-surface)] p-1 gap-1 flex-wrap justify-center">
            <button
              data-testid="tab-monitoring"
              onClick={() => setActiveTab('monitoring')}
              className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold transition-all ${
                activeTab === 'monitoring'
                  ? 'bg-[#a855f7] text-white shadow-sm'
                  : 'text-[var(--color-text-muted)] hover:bg-[var(--color-surface-alt)] hover:text-[var(--color-text)]'
              }`}
            >
              <Eye className="w-4 h-4" />
              SEO Agent
            </button>
            <button
              data-testid="tab-keyword-research"
              onClick={() => setActiveTab('keyword')}
              className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold transition-all ${
                activeTab === 'keyword'
                  ? 'bg-[#a855f7] text-white shadow-sm'
                  : 'text-[var(--color-text-muted)] hover:bg-[var(--color-surface-alt)] hover:text-[var(--color-text)]'
              }`}
            >
              <BookOpen className="w-4 h-4" />
              {t.keyword_research}
            </button>
            <button
              data-testid="tab-content-writer"
              onClick={() => setActiveTab('content')}
              className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold transition-all ${
                activeTab === 'content'
                  ? 'bg-[#a855f7] text-white shadow-sm'
                  : 'text-[var(--color-text-muted)] hover:bg-[var(--color-surface-alt)] hover:text-[var(--color-text)]'
              }`}
            >
              <PenLine className="w-4 h-4" />
              {t.content_writer}
            </button>
            <button
              data-testid="tab-backlink-checker"
              onClick={() => setActiveTab('backlinks')}
              className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold transition-all ${
                activeTab === 'backlinks'
                  ? 'bg-[#a855f7] text-white shadow-sm'
                  : 'text-[var(--color-text-muted)] hover:bg-[var(--color-surface-alt)] hover:text-[var(--color-text)]'
              }`}
            >
              <Shield className="w-4 h-4" />
              {t.backlink_checker}
            </button>
            <button
              data-testid="tab-site-speed"
              onClick={() => setActiveTab('speed')}
              className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold transition-all ${
                activeTab === 'speed'
                  ? 'bg-[#a855f7] text-white shadow-sm'
                  : 'text-[var(--color-text-muted)] hover:bg-[var(--color-surface-alt)] hover:text-[var(--color-text)]'
              }`}
            >
              <Zap className="w-4 h-4" />
              {t.site_speed}
            </button>
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === 'monitoring' ? (
          <MonitoringDashboard t={t} language={language} userEmail={userEmail} />
        ) : activeTab === 'keyword' ? (
          <KeywordResearchTool t={t} language={language} userEmail={userEmail} />
        ) : activeTab === 'content' ? (
          <ContentWriterTool t={t} language={language} userEmail={userEmail} />
        ) : activeTab === 'backlinks' ? (
          <BacklinkCheckerTool t={t} language={language} userEmail={userEmail} />
        ) : (
          <SiteSpeedTool t={t} language={language} userEmail={userEmail} />
        )}
      </div>
    </section>
  );
};
